import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { markProcoDocumentAsVerified } from "../../../../../lib/fetchApi";
import Button from "../../../../common/Button";
import { notificationActions } from "../../../../../store/notifications";
import { caseActions } from "../../../../../store/case";

export default function VerifiyDocument({children, documentId, type}) {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const activeCase = useSelector(state => state.case.activeCase) 
    const userToken = useSelector(state => state.user.token)

    async function verifyDocumentHandler() {
        setLoading(true)
        try {
            let update = await markProcoDocumentAsVerified(userToken, activeCase.case.id, documentId)

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError({errorMessage: update}))
                
            } else {
                // /success 
                dispatch(caseActions.replaceItemInProcoDocuments(update))
            }
        } finally {
            setLoading(false)
        }
    }

    
    return <Button btnStyle={type == 'viewed' ? 'document_verify' : 'document_upload'} click={verifyDocumentHandler} isLoading={loading}>
        {children}        
    </Button>
}